import Player from '@vimeo/player';

let player = null;

/**
 * Initialize the Vimeo player.
 */
const initializePlayer = () => {
  const playerContainer = document.getElementById( 'hero-vimeo-player' );

  if (!playerContainer || player !== null) {
    return;
  }

  const vimeoId = playerContainer.getAttribute( 'data-hero-vimeo-id' );
  const playPauseButton = document.querySelector( '.denhaag-hero__play-pause' );

  player = new Player( 'hero-vimeo-player', {
    id: vimeoId,
    loop: true,
    background: true,
    // Respect user's reduced motion preference.
    autoplay: ! window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches,
    controls: false,
    muted: true
  } );

  player.setVolume( 0 ).catch( handleError );

  player.on( 'play', () => updatePlayPauseButton( false ) );
  player.on( 'pause', () => updatePlayPauseButton( true ) );

  playPauseButton.addEventListener( 'click', togglePlayPause );
};

/**
 * Destroy the Vimeo player instance.
 */
const destroyPlayer = () => {
  if (player === null) return;

  player.unload().then( () => {
    player.destroy();
    player = null;
    const playerContainer = document.getElementById( 'hero-vimeo-player' );
    if (playerContainer) {
      playerContainer.removeAttribute( 'data-vimeo-initialized' );
      playerContainer.innerHTML = '';
    }
  } ).catch( handleError );

  const playPauseButton = document.querySelector( '.denhaag-hero__play-pause' );
  if (playPauseButton) {
    playPauseButton?.removeEventListener( 'click', togglePlayPause );
  }
};

/**
 * Toggle play/pause state of the Vimeo player.
 */
const togglePlayPause = () => {
  if (player === null) return;

  player.getPaused()?.then( (paused) => {
    if (paused) {
      player.play().then( () => updatePlayPauseButton( false ) ).catch( handleError );
    } else {
      player.pause().then( () => updatePlayPauseButton( true ) ).catch( handleError );
    }
  } ).catch( handleError );
};

const updatePlayPauseButton = (paused) => {
  const playPauseButton = document.querySelector( '.denhaag-hero__play-pause' );
  const playIcon = playPauseButton.querySelector( '.play-icon' );
  const pauseIcon = playPauseButton.querySelector( '.pause-icon' );
  const playText = playIcon.getAttribute( 'data-sr-text' );
  const pauseText = pauseIcon.getAttribute( 'data-sr-text' );

  playIcon.style.display = paused ? 'inline' : 'none';
  pauseIcon.style.display = paused ? 'none' : 'inline';
  playPauseButton.setAttribute( 'aria-label', paused ? playText : pauseText );
};

const handleError = (error) => {
  switch (error.name) {
    case 'PasswordError':
      console.error( 'Video is password protected' );
      break;
    case 'PrivacyError':
      console.error( 'Video is private' );
      break;
    default:
      console.error( 'An error occurred:', error );
      break;
  }
};

/**
 * Initialize or destroy the Vimeo player based on window width.
 */
const initializeOrDestroyPlayer = () => window.innerWidth <= 767 ? destroyPlayer() : initializePlayer();

export {initializePlayer, destroyPlayer,initializeOrDestroyPlayer};
